import { QualityScore } from '../../Quality/Quality';
import { stateType } from '../../../AppStateProvider/AppStateProvider';
import { useCallback } from 'react';
import { getQualityScore } from '../../Quality/getQualityScore/getQualityScore';
import { axiosApiInstance } from '../../../AppStateProvider/authentification/axiosApiInstanse';

export function useAddHistoryResult(state: stateType, userAgentInfo: UAParser.IResult) {
  return useCallback(() => {
    return new Promise(async () => {
      const { bitrateUDP, bitrateTCP, totalQualityScore } = getQualityScore(
        state.bitrateTestUDP.reportUDP,
        state.bitrateTestTCP.reportTCP
      );
      const browser = userAgentInfo.browser;
      const connectivityTestPassed = state.sipConnectivityUSTestConnected && state.sipConnectivitySATestConnected;
      const codecsTestsPassed = state.videoCodecTestSuccessful && state.audioCodecTestSuccessful;
      const qualityScore = QualityScore[totalQualityScore].toLowerCase();
      const browserTestPassed = browser.name === 'Chrome';

      const finalTestResults = {
        testResults: {
          browserTestPassed: browserTestPassed,
          connectivityResults: {
            connectivityTestPassed: connectivityTestPassed,
            sipConnectivityUSStatus: state.sipConnectivityUSTestConnected,
            sipConnectivitySAStatus: state.sipConnectivitySATestConnected,
          },
          codecsTestResult: {
            codecsTestsPassed: codecsTestsPassed,
            audioCodecTestStatus: state.audioCodecTestSuccessful,
            audioCodecTestReport: state.audioCodecTestReport,
            videoCodecTestStatus: state.videoCodecTestSuccessful,
            videoCodecTestReport: state.videoCodecTestReport,
          },
          qualityTestResult: {
            qualityTestPassed: true,
            qualityScore: qualityScore,
            bitrateUDP: bitrateUDP,
            bitrateTCP: bitrateTCP,
            isTCPEnabled: state.bitrateTestTCP.enabled,
            downloadSpeed: state.downloadSpeedResult,
            uploadSpeed: state.uploadSpeedResult,
            rttResult: state.rttResult,
            jitterResult: state.jitterResult,
          },
        },
      };
      await axiosApiInstance.post(process.env.REACT_APP_API! + '/addResult', finalTestResults);
    });
  }, [state, userAgentInfo]);
}
